import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Base from '../Base';
import Card from '../../components/elements/Card';
import Loading from '../../components/common/Loading';
import Title from '../../components/common/Title';
import { apiRequest } from '../../utils';
import { StatusPill } from './SupplierEvent';
import './Supplier.css';

/* The supplier portal's front page: the events this company works on, soonest first, each with
   how far its request got. A supplier lands on one event straight from the link in its mail or
   WhatsApp; this is where it finds the others. */
const SupplierHome = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [denied, setDenied] = useState(false);

  useEffect(() => {
    apiRequest('GET', '/supplier/home').then(setData).catch(() => setDenied(true));
  }, []);

  if (!data && !denied) return <Base activeNav="home"><Loading /></Base>;

  return (
    <Base activeNav="home">
      <Title>{data ? data.supplier.name : t('opsPortalTitle')}</Title>
      <Card>
        {denied && <p className="ops-hint">{t('opsNoAccess')}</p>}
        {data && !data.events.length && <p className="ops-hint">{t('opsNoEvents')}</p>}
        {data && data.events.map((ev) => (
          <button type="button" key={ev.id} className="ops-event-row"
                  onClick={() => navigate(`/supplier/event/${ev.id}`)}>
            <span className="ops-event-row__main">
              <span className="ops-event-row__name">{ev.name}</span>
              <span className="ops-event-row__sub">{[ev.date, ev.venue].filter(Boolean).join(' · ')}</span>
            </span>
            {ev.request && <StatusPill request={ev.request} />}
          </button>
        ))}
        {data && (
          <p className="ops-hint">{t('opsRosterCount', { people: data.people, vehicles: data.vehicles })}</p>
        )}
      </Card>
    </Base>
  );
};

export default SupplierHome;
